import localforage from "localforage";

export const getCachedKey = async (key: string): Promise<any> => {
  return (await localforage.getItem(key)) ?? {};
};

export const getCachedKeyTime = async (key: string): Promise<number> => {
  const cachedKeyTime: number =
    (await localforage.getItem(key)) ?? 0;
  return cachedKeyTime;
};

export const updateCachedKeyTime = async (key: string, time: number): Promise<void> => {
  await localforage.setItem(key, time);
};

export const updateCachedKey = async (key: string, Key: any): Promise<void> => {
  await localforage.setItem(key, Key);
};